import { clearWelcomeBannerSession } from '../hooks/useWelcomeBanner';

export const clearAuthSession = () => {
  localStorage.removeItem('isLogin');
  localStorage.removeItem('login');
  localStorage.removeItem('token');
  localStorage.removeItem('UserRole');
  localStorage.removeItem('userData');
  localStorage.removeItem('deviceData');
  clearWelcomeBannerSession();
};

export const logout = (navigate) => {
  clearAuthSession();
  navigate('/');
};
